import React, { Component } from 'react'
import UserList from "./UserList";

class UserManagement extends Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        this.props.getUsers();
    }
    render() {
        /*console.log(this.props.data)
        console.log(this.props.type)*/
        return (
            <React.Fragment>
               <UserList data={this.props.data} isAdmin={this.props.isAdmin}/>)
            </React.Fragment>
        )
    }
}

export default UserManagement
